import { AllFilters } from '../NewDashboard/hooks/utils'
import dayjs from 'dayjs'

export const ADD_TODO_HASH_ROUTE = 'add-todo'

export const initialFiltersValue: AllFilters = {
  rangePicker: [dayjs(), dayjs()],
  residents: [],
  categories: [],
  status: [],
  categoryItems: [],
  search: '',
}
